import { SET_PASSWORD_EXPIRED } from '../constants/actionTypes'

export const setPasswordExpired = (passwordExpired) => ({
  type: SET_PASSWORD_EXPIRED,
  passwordExpired,
})
